import { IDENTITY_PATHS } from '@words-happen/app-urls';

export const ROUTES = {
  home: '/',
  signIn: IDENTITY_PATHS.signIn,
  register: IDENTITY_PATHS.register,
  signOut: IDENTITY_PATHS.signOut,
  /** Kept for old links and history entries: goes straight on to the game's home. */
  signedIn: '/signed-in',
  /** "Check your email": an unverified player waits here to verify, and verification links continue here. */
  verifyEmail: '/verify-email',
  /** Where a verification link's oobCode is applied (the custom action handler, ENG-852). */
  verifyEmailConfirm: '/verify-email/confirm',
  /** Requests a password reset email. The game app's profile links here, with return_to set to the profile. */
  forgotPassword: IDENTITY_PATHS.forgotPassword,
  /** Where a reset link's oobCode sets a new password (the custom action handler, ENG-852). */
  resetPassword: '/reset-password',
  /** Where a sign-in link's oobCode signs the player in. Its emails continue here, keeping return_to. */
  signInLink: '/sign-in/link',
} as const;

/** A route the identity screens move between, keeping return_to and provider. */
export type IdentityRoute = (typeof ROUTES)[Exclude<keyof typeof ROUTES, 'home'>];
